import React from 'react'
import {connect} from 'react-redux'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import styles from './b2bCompanyClientContracts.scss'
import {setOpenedSubmenu} from 'state/actions'
import ContractZoom from '../clients/clientContractsZoom'
import RefreshBtn from './../refreshBtn'

import i18n from 'lib/i18n'
const _ = i18n('clientContracts')

const Results = ({data, selectedContract, checkIt, onRefresh}) => {
	const icons = {
		0: 'c-credit',
		1: 'c-life',
		2: 'c-health',
		3: 'c-home',
		4: 'c-family',
		5: 'c-automotive',
		6: 'c-workinjuries',
		7: 'c-fire',
		8: 'c-transport',
		9: 'c-misc',
	}
	return (
		<div className={styles.clientsTableContainer}>
			<Table
				className={styles.table}
				itemsPerPage={10}
				filterable={[
					"contractNumber",
					"mainBranche",
					"mainRisk",
					"insuranceCompany",
					"contractState",
				]}
				sortable={[
					"contractNumber",
					"mainBranche",
					"mainRisk",
					"insuranceCompany",
					"contractState",
				]}
				defaultSort={{
					column: 'contractState',
					direction: 'asc',
                }}
                topPaginationElemL={
                    [
                        <RefreshBtn
                            key="r"
                            onClick={() => {
                                onRefresh(true)
                            }}
                        />,
                    ]
                }
			>
				<Thead>
					<Th column="contractCheck" label=""/>
					<Th column="claimIcon" label=""/>
					<Th column="contractNumber">
						<strong>{_('contractNumber')}</strong>
					</Th>
					<Th column="mainBranche">
						<strong>{_('mainBranche')}</strong>
					</Th>
					<Th column="mainRisk">
						<strong>{_('mainRisk')}</strong>
					</Th>
					<Th column="insuranceCompany">
						<strong>{_('insuranceCompany')}</strong>
					</Th>
					<Th column="contractState">
						<strong>{_('contractState')}</strong>
					</Th>
				</Thead>
				{data && data.map((item, key) =>
					<Tr
						className="centered clickable"
						key={key} onClick={() => checkIt(item)}
					>
						<Td column="contractCheck">
							<input type="radio"
								checked={selectedContract && (selectedContract.contractNumber === item.contractNumber) || false}
							/>
						</Td>
						<Td column="claimIcon">
							<div className={styles.iconContainer}>
								<img src={require(`resources/images/${icons[item.brancheCode]}_2x.png`)}/>
							</div>
						</Td>
						<Td column="contractNumber">{item.contractNumber}</Td>
						<Td column="mainBranche">{item.mainBranche}</Td>
						<Td column="mainRisk">{item.mainRisk}</Td>
						<Td column="insuranceCompany">{item.insuranceCompany}</Td>
						<Td column="contractState">{item.contractState}</Td>
					</Tr>
					)
				}
			</Table>
		</div>
	)
}
@connect(state => {
	const clientId = state.b2bCompany.opened
	const clientData = state.clients.clientData[clientId]
	const contracts = clientData.contractIds.map(id => state.contracts[id])
	return {
		allContracts: state.contracts,
		contracts,
		selectedPolicy: state.b2bCompany.selectedPolicy,
		subModuleZoom: state.clients.subModuleZoom,
	}
})
export default class B2bCompanyClientContracts extends React.Component {
	static propTypes = {
		onSelectEdit: React.PropTypes.func.isRequired,
		onRefresh: React.PropTypes.func.isRequired,
		dispatch: React.PropTypes.func.isRequired,
		data: React.PropTypes.array,
		selectedPolicy: React.PropTypes.object,
	}

	render() {
        const {allContracts, contracts, selectedPolicy, dispatch, subModuleZoom, onSelectEdit,
            onRefresh} = this.props
		let contract = selectedPolicy && allContracts[selectedPolicy.contractId]
		if (!contract && subModuleZoom) {
			const key = Object.keys(subModuleZoom)[0]
			if (key) {
				const value = subModuleZoom[key]
				contract = contracts.find(c => c[key] === value)
			}
		}
		return (
			<div className={styles.moduleSection}>
				{contracts.length > 0 ?
					<Results
						data={contracts}
						selectedContract={contract}
                        checkIt={contract => onSelectEdit(contract)}
                        onRefresh={onRefresh}
					/> :
					null
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2bCompany/b2bCompanyClientContracts.jsx